"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.assign.js");
var _react = _interopRequireDefault(require("react"));
var _models = require("../../models");
var _constants = require("../../../utils/constants");
var _CubeModel = _interopRequireDefault(require("../Models/CubeModel"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const ItemConnector = props => /*#__PURE__*/_react.default.createElement("group", _extends({
  position: [0, 0, 0]
}, props), /*#__PURE__*/_react.default.createElement("group", {
  position: [0, 10, 0]
}, /*#__PURE__*/_react.default.createElement(_CubeModel.default, {
  position: [0, 0, -0.25],
  args: [1, 1, 0.5],
  highlightsType: _constants.pipesTypes.chilledWater
}), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
  scale: [1, 1, 1.7],
  position: [0, 0, -0.5],
  rotation: [0, 0, 0],
  highlightsType: _constants.pipesTypes.chilledWater
})), /*#__PURE__*/_react.default.createElement("group", {
  position: [0, 20, 0]
}, /*#__PURE__*/_react.default.createElement(_CubeModel.default, {
  position: [0, 0, -0.25],
  args: [1, 1, 0.5],
  highlightsType: _constants.pipesTypes.circulation
}), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
  scale: [1, 1, 1.1],
  position: [0, 0, -0.5],
  rotation: [0, 0, 0],
  highlightsType: _constants.pipesTypes.circulation
})), /*#__PURE__*/_react.default.createElement("group", {
  position: [0, 30, 0]
}, /*#__PURE__*/_react.default.createElement(_CubeModel.default, {
  position: [0, 0, -0.25],
  args: [1, 1, 0.5],
  highlightsType: _constants.pipesTypes.hotWater
}), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
  scale: [1, 1, 1.3],
  position: [0, 0, -0.5],
  rotation: [0, 0, 0],
  highlightsType: _constants.pipesTypes.hotWater
})));
var _default = exports.default = ItemConnector;